export default __webpack_public_path__ + "static/dTGwqAuc-e35760a91c4f3620fe4839ca7ffe6334.svg";